import { useCallback } from 'react';

import FertProductSelect from 'components/FertProductSelect';
import { useField } from 'formik';

import type { IFertProductSelectFieldProps } from './types';

export default function FertProductSelectField({
  name,
  disabled,
  location,
  subGroup,
  onChange,
  textFieldProps,
}: IFertProductSelectFieldProps) {
  const [{ value }, metaId, { setValue, setTouched }] = useField(name);

  const hasError = Boolean(metaId.touched && metaId.error);
  const helperText = hasError ? metaId.error : '';

  const handleOnBlur = useCallback(async () => {
    if (!metaId.touched) await setTouched(true, false);
  }, [setTouched, metaId]);

  const handleChange = useCallback(
    async (value) => {
      const newVal = value ? value.itemGroupRef : '';

      await setValue(newVal, true);
      if (onChange) onChange(newVal);
    },
    [onChange, setValue],
  );

  return (
    <FertProductSelect
      disabled={disabled}
      location={location}
      selectedProductReference={value}
      onChange={handleChange}
      subGroup={subGroup}
      textFieldProps={{
        name: name,
        error: hasError,
        helperText: helperText,
        onBlur: handleOnBlur,
        ...textFieldProps,
      }}
    />
  );
}
